import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useAuthStore } from '../stores/auth'
import type { ClientDto } from '@emag/shared'

export function DashboardPage() {
  const user = useAuthStore((s) => s.user)
  const { data } = useQuery({
    queryKey: ['clients'],
    queryFn: async () => (await api.get<{ clients: ClientDto[] }>('/clients')).data.clients,
  })

  const clients = data ?? []
  const active = clients.filter((c) => c.active).length
  const configured = clients.filter((c) => c.hasEmagConfig && c.hasEaConfig).length

  const cards = [
    { label: 'Clienți', value: clients.length, color: 'text-b4l-green' },
    { label: 'Activi', value: active, color: 'text-b4l-blue' },
    { label: 'Configurați complet', value: configured, color: 'text-b4l-purple' },
  ]

  return (
    <div>
      <h1 className="mb-1 text-lg font-semibold text-b4l-text">Dashboard</h1>
      <p className="mb-5 text-[13px] text-b4l-text-dim">Bine ai venit, {user?.name}.</p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="rounded-xl border border-b4l-border bg-white p-4">
            <div className={`text-2xl font-semibold ${c.color}`}>{c.value}</div>
            <div className="text-[12px] text-b4l-text-muted">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
